import React from 'react';
import ReactDOM from 'react-dom/client';



import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Layout from './components/Layout';

import Contact from './pages/Contact';

import UserLogin from './pages/UserLogin';
import Checkout from './pages/Checkout';
import SignUp from './pages/SignUp';
import Jewelry from './pages/Jewelry';
import ArtProducts from './pages/ArtProducts'
import EverythingElse from './pages/EverythingElse'
import Clothing from './pages/Clothing'








export default function App() {
  return (
   
      
      <BrowserRouter>
      <Layout />
      
      <Routes>
       
        <Route  exact path= 'Contact' element= {<Contact />} />
        <Route  path = 'ArtProducts' element={<ArtProducts/>}/>
        <Route path = 'Clothing' element={<Clothing />}/>
        <Route  path = 'Jewelry' element={<Jewelry />}/>
        <Route  path = 'EverythingElse' element={<EverythingElse />} />
          <Route  path= 'SignUp' element ={<SignUp/>}/>
          <Route  path= 'Checkout' elementt ={<Checkout/>}/>
          <Route  path= 'UserLogin' element ={<UserLogin />}/>

        
      </Routes>
      </BrowserRouter>
    
  );
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
	

);



